import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'configuration-management-api.vendasta-local.com',
  'test': '',
  'demo': 'configuration-management-demo.apigateway.co',
  'prod': 'configuration-management-prod.apigateway.co',
  'production': 'configuration-management-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ObjectApplicationStrategy = /*#__PURE__*/function (ObjectApplicationStrategy) {
  ObjectApplicationStrategy[ObjectApplicationStrategy["OBJECT_APPLICATION_STRATEGY_UNSPECIFIED"] = 0] = "OBJECT_APPLICATION_STRATEGY_UNSPECIFIED";
  ObjectApplicationStrategy[ObjectApplicationStrategy["OBJECT_APPLICATION_STRATEGY_SKIP_EXISTING"] = 1] = "OBJECT_APPLICATION_STRATEGY_SKIP_EXISTING";
  ObjectApplicationStrategy[ObjectApplicationStrategy["OBJECT_APPLICATION_STRATEGY_OVERWRITE_EXISTING"] = 2] = "OBJECT_APPLICATION_STRATEGY_OVERWRITE_EXISTING";
  return ObjectApplicationStrategy;
}(ObjectApplicationStrategy || {});
var OwnerNamespaceType = /*#__PURE__*/function (OwnerNamespaceType) {
  OwnerNamespaceType[OwnerNamespaceType["OWNER_NAMESPACE_UNSPECIFIED"] = 0] = "OWNER_NAMESPACE_UNSPECIFIED";
  OwnerNamespaceType[OwnerNamespaceType["OWNER_NAMESPACE_PARTNER"] = 1] = "OWNER_NAMESPACE_PARTNER";
  return OwnerNamespaceType;
}(OwnerNamespaceType || {});
var SourceNamespaceType = /*#__PURE__*/function (SourceNamespaceType) {
  SourceNamespaceType[SourceNamespaceType["SOURCE_NAMESPACE_UNSPECIFIED"] = 0] = "SOURCE_NAMESPACE_UNSPECIFIED";
  SourceNamespaceType[SourceNamespaceType["SOURCE_NAMESPACE_PARTNER"] = 1] = "SOURCE_NAMESPACE_PARTNER";
  SourceNamespaceType[SourceNamespaceType["SOURCE_NAMESPACE_ACCOUNT_GROUP"] = 2] = "SOURCE_NAMESPACE_ACCOUNT_GROUP";
  return SourceNamespaceType;
}(SourceNamespaceType || {});
var TargetContainerNamespaceType = /*#__PURE__*/function (TargetContainerNamespaceType) {
  TargetContainerNamespaceType[TargetContainerNamespaceType["TARGET_CONTAINER_NAMESPACE_UNSPECIFIED"] = 0] = "TARGET_CONTAINER_NAMESPACE_UNSPECIFIED";
  TargetContainerNamespaceType[TargetContainerNamespaceType["TARGET_CONTAINER_NAMESPACE_ACCOUNT_GROUP"] = 1] = "TARGET_CONTAINER_NAMESPACE_ACCOUNT_GROUP";
  TargetContainerNamespaceType[TargetContainerNamespaceType["TARGET_CONTAINER_NAMESPACE_GROUP"] = 2] = "TARGET_CONTAINER_NAMESPACE_GROUP";
  return TargetContainerNamespaceType;
}(TargetContainerNamespaceType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ApplyConfigurationRequest {
  static fromProto(proto) {
    let m = new ApplyConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.configurationTargetContainers) {
      m.configurationTargetContainers = proto.configurationTargetContainers.map(ConfigurationTargetContainer.fromProto);
    }
    if (proto.objectApplicationSelections) {
      m.objectApplicationSelections = proto.objectApplicationSelections.map(ObjectApplicationSelection.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configurationId !== 'undefined') {
      toReturn['configurationId'] = this.configurationId;
    }
    if (typeof this.configurationTargetContainers !== 'undefined' && this.configurationTargetContainers !== null) {
      toReturn['configurationTargetContainers'] = 'toApiJson' in this.configurationTargetContainers ? this.configurationTargetContainers.toApiJson() : this.configurationTargetContainers;
    }
    if (typeof this.objectApplicationSelections !== 'undefined' && this.objectApplicationSelections !== null) {
      toReturn['objectApplicationSelections'] = 'toApiJson' in this.objectApplicationSelections ? this.objectApplicationSelections.toApiJson() : this.objectApplicationSelections;
    }
    if (typeof this.autoApplyNewVersions !== 'undefined') {
      toReturn['autoApplyNewVersions'] = this.autoApplyNewVersions;
    }
    if (typeof this.runUsingServiceAccountUserId !== 'undefined') {
      toReturn['runUsingServiceAccountUserId'] = this.runUsingServiceAccountUserId;
    }
    return toReturn;
  }
}
class ApplyConfigurationResponse {
  static fromProto(proto) {
    let m = new ApplyConfigurationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class Configuration {
  static fromProto(proto) {
    let m = new Configuration();
    m = Object.assign(m, proto);
    if (proto.configurationOwner) {
      m.configurationOwner = ConfigurationOwner.fromProto(proto.configurationOwner);
    }
    if (proto.sourceNamespaceType) {
      m.sourceNamespaceType = enumStringToValue(SourceNamespaceType, proto.sourceNamespaceType);
    }
    if (proto.configurationVersion) {
      m.configurationVersion = ConfigurationVersion.fromProto(proto.configurationVersion);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.updatedAt) {
      m.updatedAt = new Date(proto.updatedAt);
    }
    if (proto.deletedAt) {
      m.deletedAt = new Date(proto.deletedAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configurationId !== 'undefined') {
      toReturn['configurationId'] = this.configurationId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.configurationOwner !== 'undefined' && this.configurationOwner !== null) {
      toReturn['configurationOwner'] = 'toApiJson' in this.configurationOwner ? this.configurationOwner.toApiJson() : this.configurationOwner;
    }
    if (typeof this.sourceNamespaceType !== 'undefined') {
      toReturn['sourceNamespaceType'] = this.sourceNamespaceType;
    }
    if (typeof this.configurationVersion !== 'undefined' && this.configurationVersion !== null) {
      toReturn['configurationVersion'] = 'toApiJson' in this.configurationVersion ? this.configurationVersion.toApiJson() : this.configurationVersion;
    }
    if (typeof this.deployedVersion !== 'undefined') {
      toReturn['deployedVersion'] = this.deployedVersion;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? this.createdAt.toApiJson() : this.createdAt;
    }
    if (typeof this.updatedAt !== 'undefined' && this.updatedAt !== null) {
      toReturn['updatedAt'] = 'toApiJson' in this.updatedAt ? this.updatedAt.toApiJson() : this.updatedAt;
    }
    if (typeof this.deletedAt !== 'undefined' && this.deletedAt !== null) {
      toReturn['deletedAt'] = 'toApiJson' in this.deletedAt ? this.deletedAt.toApiJson() : this.deletedAt;
    }
    return toReturn;
  }
}
class ConfigurationOwner {
  static fromProto(proto) {
    let m = new ConfigurationOwner();
    m = Object.assign(m, proto);
    if (proto.ownerNamespaceType) {
      m.ownerNamespaceType = enumStringToValue(OwnerNamespaceType, proto.ownerNamespaceType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerNamespace !== 'undefined') {
      toReturn['ownerNamespace'] = this.ownerNamespace;
    }
    if (typeof this.ownerNamespaceType !== 'undefined') {
      toReturn['ownerNamespaceType'] = this.ownerNamespaceType;
    }
    return toReturn;
  }
}
class ConfigurationSource {
  static fromProto(proto) {
    let m = new ConfigurationSource();
    m = Object.assign(m, proto);
    if (proto.sourceNamespaceType) {
      m.sourceNamespaceType = enumStringToValue(SourceNamespaceType, proto.sourceNamespaceType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceNamespace !== 'undefined') {
      toReturn['sourceNamespace'] = this.sourceNamespace;
    }
    if (typeof this.sourceNamespaceType !== 'undefined') {
      toReturn['sourceNamespaceType'] = this.sourceNamespaceType;
    }
    return toReturn;
  }
}
class ConfigurationTargetContainer {
  static fromProto(proto) {
    let m = new ConfigurationTargetContainer();
    m = Object.assign(m, proto);
    if (proto.targetContainerNamespaceType) {
      m.targetContainerNamespaceType = enumStringToValue(TargetContainerNamespaceType, proto.targetContainerNamespaceType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.targetContainerNamespace !== 'undefined') {
      toReturn['targetContainerNamespace'] = this.targetContainerNamespace;
    }
    if (typeof this.targetContainerNamespaceType !== 'undefined') {
      toReturn['targetContainerNamespaceType'] = this.targetContainerNamespaceType;
    }
    return toReturn;
  }
}
class ConfigurationVersion {
  static fromProto(proto) {
    let m = new ConfigurationVersion();
    m = Object.assign(m, proto);
    if (proto.objectTypes) {
      m.objectTypes = proto.objectTypes.map(TypedObjectContainer.fromProto);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.deletedAt) {
      m.deletedAt = new Date(proto.deletedAt);
    }
    if (proto.lastDeployedAt) {
      m.lastDeployedAt = new Date(proto.lastDeployedAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configurationId !== 'undefined') {
      toReturn['configurationId'] = this.configurationId;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.sourceNamespace !== 'undefined') {
      toReturn['sourceNamespace'] = this.sourceNamespace;
    }
    if (typeof this.objectTypes !== 'undefined' && this.objectTypes !== null) {
      toReturn['objectTypes'] = 'toApiJson' in this.objectTypes ? this.objectTypes.toApiJson() : this.objectTypes;
    }
    if (typeof this.createdBy !== 'undefined') {
      toReturn['createdBy'] = this.createdBy;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? this.createdAt.toApiJson() : this.createdAt;
    }
    if (typeof this.deletedAt !== 'undefined' && this.deletedAt !== null) {
      toReturn['deletedAt'] = 'toApiJson' in this.deletedAt ? this.deletedAt.toApiJson() : this.deletedAt;
    }
    if (typeof this.lastDeployedAt !== 'undefined' && this.lastDeployedAt !== null) {
      toReturn['lastDeployedAt'] = 'toApiJson' in this.lastDeployedAt ? this.lastDeployedAt.toApiJson() : this.lastDeployedAt;
    }
    return toReturn;
  }
}
class CreateConfigurationFromSourceRequest {
  static fromProto(proto) {
    let m = new CreateConfigurationFromSourceRequest();
    m = Object.assign(m, proto);
    if (proto.configurationSource) {
      m.configurationSource = ConfigurationSource.fromProto(proto.configurationSource);
    }
    if (proto.selectedTypedObjectIds) {
      m.selectedTypedObjectIds = proto.selectedTypedObjectIds.map(TypedObjectIds.fromProto);
    }
    if (proto.configurationOwner) {
      m.configurationOwner = ConfigurationOwner.fromProto(proto.configurationOwner);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configurationSource !== 'undefined' && this.configurationSource !== null) {
      toReturn['configurationSource'] = 'toApiJson' in this.configurationSource ? this.configurationSource.toApiJson() : this.configurationSource;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.selectedTypedObjectIds !== 'undefined' && this.selectedTypedObjectIds !== null) {
      toReturn['selectedTypedObjectIds'] = 'toApiJson' in this.selectedTypedObjectIds ? this.selectedTypedObjectIds.toApiJson() : this.selectedTypedObjectIds;
    }
    if (typeof this.configurationOwner !== 'undefined' && this.configurationOwner !== null) {
      toReturn['configurationOwner'] = 'toApiJson' in this.configurationOwner ? this.configurationOwner.toApiJson() : this.configurationOwner;
    }
    return toReturn;
  }
}
class CreateConfigurationFromSourceResponse {
  static fromProto(proto) {
    let m = new CreateConfigurationFromSourceResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configurationId !== 'undefined') {
      toReturn['configurationId'] = this.configurationId;
    }
    return toReturn;
  }
}
class DeleteConfigurationRequest {
  static fromProto(proto) {
    let m = new DeleteConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configurationId !== 'undefined') {
      toReturn['configurationId'] = this.configurationId;
    }
    return toReturn;
  }
}
class GetConfigurationPreviewDataForSourceRequest {
  static fromProto(proto) {
    let m = new GetConfigurationPreviewDataForSourceRequest();
    m = Object.assign(m, proto);
    if (proto.configurationSource) {
      m.configurationSource = ConfigurationSource.fromProto(proto.configurationSource);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configurationSource !== 'undefined' && this.configurationSource !== null) {
      toReturn['configurationSource'] = 'toApiJson' in this.configurationSource ? this.configurationSource.toApiJson() : this.configurationSource;
    }
    return toReturn;
  }
}
class GetConfigurationPreviewDataForSourceResponse {
  static fromProto(proto) {
    let m = new GetConfigurationPreviewDataForSourceResponse();
    m = Object.assign(m, proto);
    if (proto.objectTypes) {
      m.objectTypes = proto.objectTypes.map(TypedObjectContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.objectTypes !== 'undefined' && this.objectTypes !== null) {
      toReturn['objectTypes'] = 'toApiJson' in this.objectTypes ? this.objectTypes.toApiJson() : this.objectTypes;
    }
    return toReturn;
  }
}
class ListConfigurationsRequest {
  static fromProto(proto) {
    let m = new ListConfigurationsRequest();
    m = Object.assign(m, proto);
    if (proto.configurationOwner) {
      m.configurationOwner = ConfigurationOwner.fromProto(proto.configurationOwner);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configurationOwner !== 'undefined' && this.configurationOwner !== null) {
      toReturn['configurationOwner'] = 'toApiJson' in this.configurationOwner ? this.configurationOwner.toApiJson() : this.configurationOwner;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListConfigurationsResponse {
  static fromProto(proto) {
    let m = new ListConfigurationsResponse();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = proto.configuration.map(Configuration.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ObjectApplicationSelection {
  static fromProto(proto) {
    let m = new ObjectApplicationSelection();
    m = Object.assign(m, proto);
    if (proto.strategy) {
      m.strategy = enumStringToValue(ObjectApplicationStrategy, proto.strategy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configurationObjectId !== 'undefined') {
      toReturn['configurationObjectId'] = this.configurationObjectId;
    }
    if (typeof this.strategy !== 'undefined') {
      toReturn['strategy'] = this.strategy;
    }
    return toReturn;
  }
}
class TypedObject {
  static fromProto(proto) {
    let m = new TypedObject();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.link !== 'undefined') {
      toReturn['link'] = this.link;
    }
    return toReturn;
  }
}
class TypedObjectContainer {
  static fromProto(proto) {
    let m = new TypedObjectContainer();
    m = Object.assign(m, proto);
    if (proto.objects) {
      m.objects = proto.objects.map(TypedObject.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.typeId !== 'undefined') {
      toReturn['typeId'] = this.typeId;
    }
    if (typeof this.typeName !== 'undefined') {
      toReturn['typeName'] = this.typeName;
    }
    if (typeof this.objects !== 'undefined' && this.objects !== null) {
      toReturn['objects'] = 'toApiJson' in this.objects ? this.objects.toApiJson() : this.objects;
    }
    return toReturn;
  }
}
class TypedObjectIds {
  static fromProto(proto) {
    let m = new TypedObjectIds();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.typeId !== 'undefined') {
      toReturn['typeId'] = this.typeId;
    }
    if (typeof this.typedObjectIds !== 'undefined') {
      toReturn['typedObjectIds'] = this.typedObjectIds;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ConfigurationManagementApiService = /*#__PURE__*/(() => {
  class ConfigurationManagementApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getConfigurationPreviewDataForSource(r) {
      const request = r.toApiJson ? r : new GetConfigurationPreviewDataForSourceRequest(r);
      return this.http.post(this._host + "/configuration_management.v1.ConfigurationManagement/GetConfigurationPreviewDataForSource", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConfigurationPreviewDataForSourceResponse.fromProto(resp)));
    }
    createConfigurationFromSource(r) {
      const request = r.toApiJson ? r : new CreateConfigurationFromSourceRequest(r);
      return this.http.post(this._host + "/configuration_management.v1.ConfigurationManagement/CreateConfigurationFromSource", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateConfigurationFromSourceResponse.fromProto(resp)));
    }
    listConfigurations(r) {
      const request = r.toApiJson ? r : new ListConfigurationsRequest(r);
      return this.http.post(this._host + "/configuration_management.v1.ConfigurationManagement/ListConfigurations", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListConfigurationsResponse.fromProto(resp)));
    }
    applyConfiguration(r) {
      const request = r.toApiJson ? r : new ApplyConfigurationRequest(r);
      return this.http.post(this._host + "/configuration_management.v1.ConfigurationManagement/ApplyConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => ApplyConfigurationResponse.fromProto(resp)));
    }
    deleteConfiguration(r) {
      const request = r.toApiJson ? r : new DeleteConfigurationRequest(r);
      return this.http.post(this._host + "/configuration_management.v1.ConfigurationManagement/DeleteConfiguration", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ConfigurationManagementApiService.ɵfac = function ConfigurationManagementApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ConfigurationManagementApiService)();
  };
  ConfigurationManagementApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ConfigurationManagementApiService,
    factory: ConfigurationManagementApiService.ɵfac,
    providedIn: 'root'
  });
  return ConfigurationManagementApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { ApplyConfigurationRequest, ApplyConfigurationResponse, Configuration, ConfigurationManagementApiService, ConfigurationOwner, ConfigurationSource, ConfigurationTargetContainer, ConfigurationVersion, CreateConfigurationFromSourceRequest, CreateConfigurationFromSourceResponse, DeleteConfigurationRequest, GetConfigurationPreviewDataForSourceRequest, GetConfigurationPreviewDataForSourceResponse, HostService, ListConfigurationsRequest, ListConfigurationsResponse, ObjectApplicationSelection, ObjectApplicationStrategy, OwnerNamespaceType, PagedRequestOptions, PagedResponseMetadata, SourceNamespaceType, TargetContainerNamespaceType, TypedObject, TypedObjectContainer, TypedObjectIds };
